'use client';

import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["options"];
import { DropdownCheckboxItem } from "../../primitive-dropdown/dropdown-checkbox-item";
import { AsyncGenericDropdown } from "./async-generic-dropdown";
import { jsx as _jsx } from "react/jsx-runtime";
export function AsyncCheckboxesDropdown(_ref) {
  var checkboxes = _ref.options,
    props = _objectWithoutProperties(_ref, _excluded);
  var options = checkboxes.map(function (option) {
    return {
      value: option.value,
      label: option.label,
      element: function element(elementProps) {
        return /*#__PURE__*/_jsx(DropdownCheckboxItem, _objectSpread({
          checkbox: option
        }, elementProps));
      }
    };
  });
  return /*#__PURE__*/_jsx(AsyncGenericDropdown, _objectSpread(_objectSpread({}, props), {}, {
    options: options,
    allowDeselect: true,
    multiselect: true
  }));
}